"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPatternHash = void 0;
const getPatternHash = (pattern) => {
    return pattern.cells
        .filter((cell) => cell.isEmpty)
        .map((cell) => {
        const blank = cell.tile.isBlank ? '!' : '';
        const tile = cell.tile.character + blank;
        return [cell.x, cell.y, tile].join(',');
    })
        .join('-');
};
exports.getPatternHash = getPatternHash;
